module.exports = __webpack_public_path__ + "static/media/frozen-arctic@2x.da97718a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/frozen-arctic@2x.png
// module id = 1355
// module chunks = 1